import React from 'react';
import { Link } from 'react-router-dom';
import _ from 'lodash';

import { m } from '../../utils';
import './reportDetails.css';

const InspectionLog = ({ open, car, isIn30Mins }) => (
  <div>
    {!_.isEmpty(car.inspection_log) && isIn30Mins ? (
      <div className="report-div">
        <p>
          <b>Last Updated: {m(car.inspection_log.updated_at).calendar()}</b>
        </p>
        {car.inspection_log.details.split('\r\n').map(line => <p key={line.slice(10)}>{line}</p>)}
        <div className="image-div">
          <img className="inspection-log-image" src={car.inspection_log.photo} alt="" />
        </div>
        {open ? (
          <Link to="/report">
            <button className="incident-button">SUBMIT REPORT</button>
          </Link>
        ) : null}
      </div>
    ) : (
        <Link to="/report">
          <button className="incident-button no-upcoming-button">
            SUBMIT REPORT
        </button>
        </Link>
      )}
  </div>
);

export default InspectionLog;



// WEBPACK FOOTER //
// ./src/components/Dashboard/InspectionLog.js